import { render, staticRenderFns } from "./_client.fields.vue?vue&type=template&id=05d8adc9&scoped=true&"
import script from "./_client.fields.vue?vue&type=script&lang=js&"
export * from "./_client.fields.vue?vue&type=script&lang=js&"
import style0 from "./_client.fields.vue?vue&type=style&index=0&id=05d8adc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d8adc9",
  null
  
)

export default component.exports